import { Smartphone } from "lucide-react";

/**
 * CTA para descargar la app móvil de ReservaManager.
 *
 * Se muestra tras confirmar/gestionar una reserva o cita. Combina un QR (visible
 * solo en pantallas anchas, donde es útil escanearlo con el móvil) y un botón
 * tappable que funciona también en móvil. Apunta a la landing /app, que decide
 * tienda (App Store ya disponible; Google Play próximamente).
 *
 * El QR se carga por URL absoluta porque el widget puede embeberse en sitios de
 * terceros (Shadow DOM o iframe), donde las rutas relativas no resolverían.
 */
const APP_PAGE_URL = "https://reservamanager.com/app";
const APP_QR_URL = "https://reservamanager.com/app-download-qr.png";

export default function AppDownloadCta() {
  return (
    <div className="mt-6 flex items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 p-4 text-left">
      <img
        src={APP_QR_URL}
        alt="Código QR para descargar la app de ReservaManager"
        loading="lazy"
        width={80}
        height={80}
        className="hidden sm:block w-20 h-20 shrink-0 rounded-lg border border-gray-200 bg-white p-1"
      />
      <div className="flex-1 min-w-0">
        <p className="flex items-center gap-1.5 text-sm font-semibold text-gray-800">
          <Smartphone className="h-4 w-4 shrink-0 text-gray-700" />
          Lleva tus reservas en el móvil
        </p>
        <p className="mb-2.5 mt-0.5 text-xs text-gray-500">
          Recordatorios, tus próximas reservas y citas, y descubre más sitios
          cerca de ti.
        </p>
        <a
          href={APP_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
        >
          Descargar la app gratis
        </a>
      </div>
    </div>
  );
}
